import * as React from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { ClickAwayListener, Popper } from '@mui/material';
import cx from 'classnames';
import { ReactComponent as ArrowSmallRightIcon } from 'assets/icons/heroicons-mini/arrow-small-right.svg';

interface Props {
  children: JSX.Element;
  isActive?: boolean;
  label: string;
  className?: string;
  divStyleOverride?: React.CSSProperties;
  showNewArrowIcon?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const NestedFilter: React.FC<Props> = ({
  children,
  label,
  isActive,
  className,
  divStyleOverride,
  showNewArrowIcon = false,
  onClick,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  return (
    <>
      <div
        className={`flex items-center cursor-pointer justify-between pl-2.5 py-3 pr-4 hover:bg-blue-200 ${
          (anchorEl || isActive) && 'text-blue-900'
        }`}
        onClick={(e) => {
          setAnchorEl(anchorEl ? null : e.currentTarget);
          if (onClick) {
            onClick(e);
          }
        }}
      >
        <h4 className="font-medium">{label}</h4>
        {showNewArrowIcon ? (
          <ArrowSmallRightIcon className="w-5 h-5 text-gray-500" />
        ) : (
          <ArrowRightAltIcon />
        )}
      </div>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="right"
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 10],
            },
          },
        ]}
        style={{ zIndex: 1110 }}
        className="shadow-md"
        disablePortal
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <div
            className={cx(
              'py-2 bg-white border border-blue-900 rounded-sm relative min-w-60',
              className
            )}
            style={divStyleOverride}
          >
            {children}
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
NestedFilter.displayName = 'TrackAndTrace.Controls.filters.NestedFilter';
